import React from 'react';
import { Infographic } from 'components/infographic/Infographic';
import { Infographics } from 'components/infographic/Infographics';

export const Component = () => {
  const image = { url: '/static/images/logo_columbia.png', width: 128, height: 63 };

  return (
    <Infographics
      title="Infographics title"
      text={
        <p>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam id malesuada libero. Sed
          in massa in leo ornare molestie ac eget libero. Pellentesque lectus sapien, interdum a
          tincidunt non, euismod a est. Nunc laoreet malesuada mauris.
        </p>
      }
      isSlice
    >
      <Infographic image={image} />
      <Infographic
        number="$600k"
        text="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam id malesuada libero.
            Sed in massa in leo ornare molestie ac eget libero."
      />
      <Infographic
        image={image}
        text="Aliquam id malesuada libero.
            Sed in massa in leo ornare molestie ac eget libero."
      />
      <Infographic number="1200" text="Lorem ipsum dolor sit amet, consectetur adipiscing elit." />
      <Infographic number="22+" text="Lorem ipsum dolor sit amet, consectetur adipiscing elit." />
      <Infographic
        number="50.000"
        text="Aliquam id malesuada libero.
            Sed in massa in leo ornare molestie ac eget libero."
      />
    </Infographics>
  );
};
